import { useQuery } from '@tanstack/react-query';
import { supabase } from '../api';

export interface PostComment {
  id: number;
  created_at: string;
  user_id: string;
  comment: string;
  post_id: string;
  user?: {
    username: string;
    avatar: string;
  };
}

const getPostComments = async (postId: string, order: string = 'newest'): Promise<PostComment[]> => {
  const { data, error } = await supabase
    .from('post_comments')
    .select(`
      *,
      user:user_profiles(username, avatar)
    `)
    .eq('post_id', postId)
    .order('created_at', { ascending: order === 'oldest' })
    .returns<PostComment[]>();

  if (error) {
    throw new Error(error.message);
  }

  return data || [];
};

export default function useGetPostCommentsByPostId(postId: string, order: string = 'newest') {
  return useQuery({
    queryKey: ['post-comments', postId, order],
    queryFn: () => getPostComments(postId, order),
    enabled: Boolean(postId),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  });
}
